import { Component, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { QuestionInfo } from '../../Common/Models/Api/Info/DynamicForm/QuestionInfo';
import { DynamicFormAnswer } from './DynamicFormAnswer';

@Component({
	standalone: false,
	selector: 'dfq-multiline',
	template: /*language=html*/ `
		<h3>
			<span>{{ data.questionNumber }}</span> {{ data.Header }} <span class="required" *ngIf="data.Required">*</span>
		</h3>
		<div class="row input">
			<visiba-input
				type="textarea"
				[formControl]="formControl"
				[(ngModel)]="data.Answer.StringValue"
				[staticplaceholder]="data.Placeholder"
				[readonly]="readonly"
			></visiba-input>
		</div>
	`,
})
export class DfqMultilineComponent {
	@Input() formId: number = null;
	@Input() data: QuestionInfo = null;
	@Input() readonly = false;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	value: any = null;

	formControl: UntypedFormControl = null;

	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	constructor() {}

	ngOnInit() {
		if (typeof this.data.Answer === 'undefined' || this.data.Answer === null)
			this.data.Answer = new DynamicFormAnswer(null, this.data.Id, this.valid);
		else this.data.Answer.Valid = this.valid;

		let validators = [];
		if (this.data.Required) validators.push(Validators.required);

		this.formControl = new UntypedFormControl(null, validators);
	}

	valid = (): boolean => {
		return this.formControl.valid;
	};
}
